import {makeAutoObservable} from "mobx";
import AuthService from "../services/AuthService";
import axios from 'axios';
import OrderService from "../services/OrderService";
import DemandService from "../services/DemandService";
import { API_URL } from "../http/index";
import config from '../config';

export default class Store {
    user = {};
    isAuth = false;
    isLoading = false;
    entityId = '';
    entitiesInWork = [];

    constructor() {
        // При живом токене держим экран загрузки до конца checkAuth: иначе первый
        // рендер видит isAuth=false и PrivateRoute теряет глубокую ссылку (/login -> /start)
        this.isLoading = !!localStorage.getItem('token');
        makeAutoObservable(this);
    }

    get positionKey() {
        return config.getPositionKeyByName(this.user.position);
    }

    setAuth(bool) {
        this.isAuth = bool;
    }

    setEntitiesInWork(entities) {
        this.entitiesInWork = entities;
    }

    setUser(user) {
        this.user = user;
    }

    setLoading(bool) {
        this.isLoading = bool;
    }

    setEntityId(entityId) {
        this.entityId = entityId;
    }

    async login(email, password, position) {
        try {
            const response = await AuthService.login(email, password, position);
            localStorage.setItem('token', response.data.accessToken);
            this.setAuth(true);
            this.setUser(response.data.user);
        } catch (e) {
            alert(e.response?.data?.message);
        }
    }

    async registration(email, password, position) {
        try {
            const response = await AuthService.registration(email, password, position);
            localStorage.setItem('token', response.data.accessToken);
            this.setAuth(true);
            this.setUser(response.data.user);
            alert("УСПЕШНО!")
        } catch (e) {
            alert(e.response?.data?.message)
        }
    }

    async logout() {
        try {
            const response = await AuthService.logout();
            localStorage.removeItem('token');
            this.setAuth(false);
            this.setUser({});
        } catch (e) {
        }
    }

    async checkEntitiesInWork() {
        try {
            let entitiesInWork;
            if (this.positionKey === 'assembler') {
                entitiesInWork = await OrderService.getOrdersInWorkByUser(false).then(data => JSON.parse(data.data));
            } else if (this.positionKey === 'packer') {
                entitiesInWork = await DemandService.getDemandsInWorkByUser(false).then(data => JSON.parse(data.data));
            }
            this.setEntitiesInWork(entitiesInWork);

        } catch (e) {
        }
    }

    async checkAuth() {
        this.setLoading(true);
        try {
            const response = await axios.get(`${API_URL}/refresh`, {withCredentials: true})
            localStorage.setItem('token', response.data.accessToken);
            this.setAuth(true);
            this.setUser(response.data.user);
        } catch (e) {
        } finally {
            this.setLoading(false);
        }
    }
}